/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import ReactPlayer from 'react-player';
import { TransitionGlobal, BoxShadow } from '../../../shared/GlobalStyles';
import Text from '../../../shared/components/Text/Text';
import { setClickedUpgradeNow } from '../ducks/calendarActions';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 952px;
  border-radius: 8px;
  padding: 24px;
  gap: 16px;
`;

const ButtonsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SaveButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  height: 32px;
  padding: 6px 16px 6px 16px;
  background: ${(props) => props.backgroundColor};
  color: white;
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  user-select: none;
  border: 1px solid ${(props) => props.backgroundColor};
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover { 
    opacity: 0.7; 
  }
`;

const CancelButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  height: 32px;
  padding: 6px 16px 6px 16px;
  color: #444444;
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  user-select: none;
  border: 2px solid #444444;
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover { 
    opacity: 0.7; 
  }
`;

const ContentContainer = styled('div')`
	display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  background: white;
  box-shadow: ${BoxShadow};
  scroll-behavior: smooth;
`;

const VideoContainer = styled('div')`
  // background-image: url(src/app/shared/images/load-monitoring-dashboard.jpg);
  background: #BDBDBD;
`;

const UpperBox = styled('div')`
  width: 100%;
  background: black;
  position: relative;
  @media screen and (max-width: 540px) {
    height: 50%; 
  }
`;

const PremiumFeatureUploadVideoModal = ({ closeModal }) => {
  const dispatch = useDispatch();
  const reactPlayerRef = useRef(null);

  return (

    <Wrapper>
      <Text fontSize='24px' fontWeight={700}>Premium Feature</Text>
      <Text fontSize='16px'>Video upload is a premium feature which is only available to Gold and Platinum members.</Text>
      <ContentContainer>
        <UpperBox>
          <VideoContainer>
            <ReactPlayer
              url='https://www.youtube.com/watch?v=QOFN6WuRqPw'
              controls
              width='100%'
              height={500}
              ref={reactPlayerRef}
            />
          </VideoContainer>
        </UpperBox>
      </ContentContainer>
      <ButtonsContainer>
        <SaveButton
          onClick={() => {
            dispatch(setClickedUpgradeNow(true));
            window.open(`${process.env.PHP_APP_URL || 'https://app.teambuildr.com'}/billing`);
          }}
          backgroundColor='#444444'
        >
          <Text color='white' fontSize='16px' fontWeight={700}>UPGRADE ACCOUNT</Text>
        </SaveButton>
        <CancelButton onClick={() => closeModal()}>
          <Text fontSize='16px' fontWeight={700}>CANCEL</Text>
        </CancelButton>
      </ButtonsContainer>
    </Wrapper>

  );
};

export default PremiumFeatureUploadVideoModal;
